<mat-toolbar class="page-header">
    <div class="header-title">
        <lib-button icon="arrow_back" color="none" textColor="muted" (click)="back()"
            tooltip="{{'form.back'|translate}}"></lib-button>
        <mat-icon>settings</mat-icon>
        {{'menu.devices.configs.title'|translate}}
    </div>

    <div class="header-actions">
        <lib-button [color]="viewMode === 'grid' ? 'primary' : 'secondary'" icon="grid_view"
            [tooltip]="'menu.devices.configs.global_view'|translate" (click)="toggleViewMode()"></lib-button>

        <lib-button [color]="multiSelectMode ? 'primary' : 'secondary'" icon="checklist"
            [tooltip]="(multiSelectMode ? 'trackers.cancel_multi_select' : 'trackers.multi_select')|translate"
            (click)="toggleMultiSelectMode()"></lib-button>

        <lib-button color="primary" icon="add" text="{{'menu.devices.configs.new_template'|translate}}"
            (click)="addConfig()"></lib-button>
    </div>
</mat-toolbar>

<div class="filters-row">
    <app-search-bar (searchText)="onSearchChange($event)"></app-search-bar>

    <div class="filters-group">
        <mat-form-field appearance="outline" class="type-filter">
            <mat-label>{{'datatable.type'|translate}}</mat-label>
            <mat-select [value]="typeFilter" (selectionChange)="onTypeFilterChange($event.value)">
                <mat-select-trigger>{{ typeFilterDisplayText }}</mat-select-trigger>
                <mat-option value="all">{{'menu.devices.configs.all_types'|translate}}</mat-option>
                <mat-option *ngFor="let type of typeOptions" [value]="type">{{ type }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="sort-order">
            <mat-label>{{'menu.devices.configs.sort'|translate}}</mat-label>
            <mat-select [value]="sortOrder" (selectionChange)="onSortOrderChange($event.value)">
                <mat-select-trigger>{{ sortOrderDisplayText }}</mat-select-trigger>
                <mat-option value="name-asc">{{'menu.devices.configs.sort_name_asc'|translate}}</mat-option>
                <mat-option value="name-desc">{{'menu.devices.configs.sort_name_desc'|translate}}</mat-option>
                <mat-option value="created-desc">{{'menu.devices.configs.sort_created_desc'|translate}}</mat-option>
                <mat-option value="created-asc">{{'menu.devices.configs.sort_created_asc'|translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div class="bulk-actions" *ngIf="multiSelectMode && selectedConfigs.length">
    <span class="bulk-selection-count">{{ selectedConfigs.length }} {{'trackers.selected'|translate}}</span>

    <lib-button color="secondary" icon="grid_view" text="{{'menu.devices.configs.view_selection'|translate}}"
        (click)="bulkView()"></lib-button>

    <lib-button color="secondary" icon="edit" text="{{'menu.devices.configs.edit_selection'|translate}}"
        (click)="bulkEditSelection()"></lib-button>

    <lib-button color="none" textColor="danger" icon="delete" text="{{'trackers.delete_selection'|translate}}"
        (click)="bulkDelete()"></lib-button>
</div>

<div class="loading-row" *ngIf="loading">
    <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
    <lib-no-data *ngIf="!configs.length" message="menu.devices.configs.no_templates" icon="settings"></lib-no-data>

    <lib-no-data *ngIf="configs.length && !displayedConfigs.length" message="form.search_no_data"
        description="form.search_no_data_desc" icon="search_off"></lib-no-data>

    <div class="table-container" *ngIf="viewMode === 'table' && displayedConfigs.length">
        <table mat-table [dataSource]="displayedConfigs" class="configs-table">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox *ngIf="multiSelectMode" [checked]="allVisibleSelected"
                        (change)="toggleSelectAll()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let config">
                    <mat-checkbox *ngIf="multiSelectMode" [(ngModel)]="config.selected"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{'datatable.name'|translate}}</th>
                <td mat-cell *matCellDef="let config" class="name-cell" (click)="openDetail(config)">{{ config.name }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{'datatable.type'|translate}}</th>
                <td mat-cell *matCellDef="let config"><span class="type-chip">{{ config.type }}</span></td>
            </ng-container>

            <ng-container matColumnDef="offlineDelay">
                <th mat-header-cell *matHeaderCellDef>{{'units.device.offline_delai'|translate}}</th>
                <td mat-cell *matCellDef="let config">{{ config.offlineDelay ? (config.offlineDelay + 's') : '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="usedBy">
                <th mat-header-cell *matHeaderCellDef>{{'menu.devices.configs.used_by'|translate}}</th>
                <td mat-cell *matCellDef="let config">
                    <span class="used-by-count" [matTooltip]="trackerNames(config)"
                        *ngIf="usedBy(config).length as usedByCountValue; else noneUsed">
                        {{ usedByCountValue }}
                    </span>
                    <ng-template #noneUsed>-</ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{'datatable.actions'|translate}}</th>
                <td mat-cell *matCellDef="let config">
                    <lib-button color="none" textColor="secondary" icon="visibility" (click)="openDetail(config)"
                        tooltip="{{'menu.devices.configs.view_detail'|translate}}"></lib-button>

                    <lib-button color="none" textColor="secondary" icon="edit" (click)="openDetail(config, true)"
                        tooltip="{{'form.edit'|translate}}"></lib-button>

                    <lib-button color="none" textColor="danger" icon="delete" (click)="deleteConfig(config)"
                        tooltip="{{'form.delete'|translate}}"></lib-button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="grid-select-all" *ngIf="viewMode === 'grid' && multiSelectMode && gridConfigs.length">
        <mat-checkbox [checked]="allGridSelected" (change)="toggleSelectAllGrid()">
            {{'menu.devices.configs.select_all'|translate}}
        </mat-checkbox>
    </div>

    <div class="configs-grid" *ngIf="viewMode === 'grid'">
        <div class="config-card" *ngFor="let config of visibleGridConfigs">
            <div class="config-card-header">
                <mat-checkbox *ngIf="multiSelectMode" [(ngModel)]="config.selected"></mat-checkbox>
                <span class="config-card-name">{{ config.name }}</span>
                <span class="type-chip">{{ config.type }}</span>
            </div>

            <div class="config-card-body">
                <div class="settings-row" *ngIf="config.offlineDelay">
                    <span class="settings-key">{{'units.device.offline_delai'|translate}}</span>
                    <span class="settings-value">{{ config.offlineDelay }}s</span>
                </div>

                <div class="settings-row" *ngFor="let entry of settingsEntries(config)">
                    <span class="settings-key">{{ entry.key }}</span>
                    <span class="settings-value">{{ entry.value }}</span>
                </div>
            </div>

            <div class="config-card-footer">
                <span class="used-by-label">{{'menu.devices.configs.used_by'|translate}}:</span>

                <span class="no-trackers" *ngIf="!usedBy(config).length">{{'menu.devices.configs.used_by_none'|translate}}</span>

                <div class="tracker-chips" *ngIf="usedBy(config).length">
                    <span class="tracker-chip" *ngFor="let tracker of usedBy(config)">{{ tracker.name }}</span>
                </div>
            </div>

            <div class="config-card-actions">
                <lib-button color="none" textColor="secondary" icon="edit" (click)="openDetail(config, true)"
                    tooltip="{{'form.edit'|translate}}"></lib-button>

                <lib-button color="none" textColor="danger" icon="delete" (click)="deleteConfig(config)"
                    tooltip="{{'form.delete'|translate}}"></lib-button>
            </div>
        </div>
    </div>
</ng-container>
